import React, { useEffect, useRef, useState } from "react";
import { animate } from "animejs";
import logo from "../media/logo-transparent.png";
import mypic from "../media/myProfilePic.png";
import tech1 from "../media/nodejs.png";
import tech2 from "../media/reactjs.png";
import tech3 from "../media/redux.png";
import tech4 from "../media/expressjs.png";
import tech5 from "../media/mongodb.png";
import tech6 from "../media/mongoose.png";
import tech7 from "../media/html.png";
import tech8 from "../media/css.png";

import project1 from "../media/project-1.webp";
import project2 from "../media/project-2.webp";
import project3 from "../media/project-3.webp";
// import project4 from '../media/project-4.webp'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

function random(min, max) {
  return Math.random() * (max - min) + min;
}
export default function Home() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const boxRef = useRef(null);
  const cardsRef = useRef(null);
  const shapesRef = useRef([]);
  const containerRef = useRef(null);
  // const animRef = useRef(null);
  const scrollTo = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = "/Aryan_Sharma_Resume.pdf"; // Relative to the public folder
    link.download = "Aryan_Sharma_Resume.pdf"; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onSubmit = async () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!name) {
      alert("Enter your name");
      return;
    }
    if (!email || !emailRegex.test(email)) {
      alert("Enter a valid email address");
      return;
    }
    try {
      const response = await fetch(
        "https://server.theboldpen.in/nodemailer",
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({ name, email, message }),
        },
      );
      if (response.ok) {
        alert("Info send Successfully!");
        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log("Some error occured", error);
    }
  };
  useEffect(() => {
    if (boxRef.current) {
      animate(".tech-logos img", {
        y: [
          { to: "-2.75rem", ease: "outExpo", duration: 600 },
          { to: 0, ease: "outBounce", duration: 800, delay: 100 },
        ],
        // rotate: {
        //     from: '-1turn',
        //     delay: 0
        // },
        delay: (_, i) => i * 100,
        ease: "inOutCirc",
        loopDelay: 1000,
        loop: true,
      });
    }
  }, []);

  useEffect(() => {
    shapesRef.current.forEach((shape) => {
      animate(shape, {
        x: random(-200, 100),
        y: random(-500, 500),
        rotate: random(-180, 180),
        duration: random(500, 1000),
        direction: "alternate",
        loop: true,
        easing: "easeInOutSine",
      });
    });
  }, []);

  // Unicorn Studio disabled for cleaner resume-focused design

  return (
    <>
      <div className="home dotted-chessboard">
        <div className="navbar">
          <div className="navbar-container">
            <div className="navbar-logo">
              <img className="header-logo" src={logo} alt="Logo" />
            </div>
            <ul className="navbar-menu">
              <li>
                <a onClick={() => scrollTo("home")} className="navbar-link">
                  Home
                </a>
              </li>
              <li>
                <a
                  onClick={() => scrollTo("technologies")}
                  className="navbar-link"
                >
                  Technologies
                </a>
              </li>
              <li>
                <a onClick={() => scrollTo("projects")} className="navbar-link">
                  Projects
                </a>
              </li>
              <li>
                <a
                  onClick={() => scrollTo("experience")}
                  className="navbar-link"
                >
                  Experience
                </a>
              </li>
              <li>
                <a
                  onClick={() => scrollTo("getintouch")}
                  className="navbar-link"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        {window.innerWidth > 576 && (
          <section id="home" className="hero-section relative overflow-hidden">
            {/* Floating particles only in this section */}
            {[...Array(40)].map((_, i) => (
              <div
                key={i}
                ref={(el) => (shapesRef.current[i] = el)}
                className="shape"
                style={{
                  position: "absolute",
                  top: `${random(5, 80)}%`,
                  left: `${random(10, 90)}%`,
                  width: "16px",
                  height: "16px",
                  backgroundColor: "rgba(255,255,255,0.15)",
                  borderRadius: "4px",
                  zIndex: 0,
                }}
              />
            ))}

            <div className="row position-relative z-10">
              <div className="col-sm-12 col-lg-6 text-start intro">
                <div className="fs-lg-1 fs-sm-3 text-silver">Aryan Sharma</div>
                <div className="fs-lg-3 fs-sm-4 text-silver mt-3">
                  Gen AI Developer 
                </div>
                <p
                  className="fs-5 text-silver"
                  style={{ lineHeight: "1.5rem" }}
                >
                  I am a product-focused full stack developer. I design and
                  build scalable web applications with a strong emphasis on
                  real-world business impact. I have hands-on experience working
                  with Node.js, React.js, MongoDB, SQL, Linux servers, Nginx,
                  and modern AI tools like n8n for workflow automation. During
                  this time, I’ve developed skills in building end-to-end
                  systems, integrating AI-driven features, and creating
                  efficient backend architectures. My goal is to leverage these
                  skills to deliver innovative, data-driven solutions that
                  enhance user experience and drive product growth.
                </p>
                <button className="btn mt-3" onClick={downloadResume}>
                  Resume
                </button>
              </div>

              <div className="col-lg-6 col-sm-12 text-center">
                <img src={mypic} className="profile-pic" alt="Profile" />
              </div>
            </div>
          </section>
        )}
        <div className="hero-section-mobile row" id="home-mobile">
          {window.innerWidth < 576 && (
            <>
              {[...Array(40)].map((_, i) => (
                <div
                  key={i}
                  ref={(el) => (shapesRef.current[i] = el)}
                  className="shape"
                  style={{
                    position: "absolute",
                    top: `${random(0, 50)}%`,
                    left: `${random(10, 90)}%`,
                    width: "16px",
                    height: "16px",
                    backgroundColor: "rgba(255,255,255,0.15)",
                    borderRadius: "4px",
                    zIndex: 0,
                  }}
                />
              ))}
              <div className="row col-12">
                <div className="col-6">
                  <div
                    className="fs-lg-1 fs-sm-3 text-silver"
                    style={{ marginTop: "2rem" }}
                  >
                    Aryan Sharma
                  </div>
                  <div className="fs-lg-3 fs-sm-4 text-silver mt-3">
                    Full Stack Developer
                  </div>
                </div>
                <div className="col-6 text-end">
                  <img src={mypic} className="profile-pic" alt="" />
                </div>
              </div>
              <div className="col-12 text-start intro">
                <p
                  className="fs-5 text-silver"
                  style={{ lineHeight: "1.5rem" }}
                >
                  I am a passionate full stack developer. I design and build web
                  applications for businesses. I have 1.5 years of experience,
                  and during this time, I've honed my skills in Node.js,
                  React.js, MongoDB, SQL, Linux servers, Nginx, and more. My
                  goal is to leverage these skills to deliver innovative,
                  scalable solutions that drive business growth and provide
                  exceptional user experiences.
                </p>
                <button className="btn mt-3" onClick={downloadResume}>
                  Resume
                </button>
              </div>
            </>
          )}
        </div>

        <div id="technologies" className="technologies px-5">
          <div>
            <p
              className="fs-1 text-silver text-center"
              style={{ marginBottom: "5rem" }}
            >
              Technologies
            </p>
          </div>
          <div className="tech-logos text-center" ref={boxRef}>
            <img className="logo1" src={tech1} alt="" />
            <img className="logo2" src={tech2} alt="" />
            <img className="logo3" src={tech3} alt="" />
            <img className="logo4" src={tech4} alt="" />
            <img className="logo5" src={tech5} alt="" />
            <img className="logo6" src={tech6} alt="" />
            <img className="logo7" src={tech7} alt="" />
            <img className="logo8" src={tech8} alt="" />
          </div>
        </div>

        <div id="projects" className="projects" ref={cardsRef}>
          <p className="fs-1 text-silver text-center">Projects</p>
          <div
            className="project-cards p-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <a
              href="https://hotelmantra.theboldpen.in"
              className="project-card-link"
              title="Click to see the live project"
            >
              <div className="card row border rounded p-0 my-">
                <div className="col-lg-3 col-sm-12">
                  <img className="rounded" src={project1} alt="" />
                </div>
                <div className="col-lg-9 col-sm-12 text-silver p-1">
                  <p className="fs-lg-3 fs-sm-4 my-3">
                    AI-Powered Hotel Management SaaS Platform
                  </p>
                  <span className="fs-5">
                    Built a multi-tenant hotel management SaaS platform to
                    handle orders, billing, inventory and daily operations for
                    hotels and restaurants. Developed real-time ordering and
                    kitchen workflows using WebSockets along with QR-based guest
                    ordering. Integrated AI agents and n8n workflow automations
                    for WhatsApp-based interactions like orders and service
                    requests. Implemented secure authentication, role-based
                    access and subscription billing with Razorpay in a modern
                    responsive dashboard.
                  </span>
                </div>
              </div>
            </a>
          </div>
          <div
            className="project-cards p-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <a
              href="https://recruitai.theboldpen.in"
              className="project-card-link"
              title="Click to see the live project"
            >
              <div className="card row border rounded p-0 my-">
                <div className="col-lg-3 col-sm-12">
                  <img className="rounded" src={project2} alt="" />
                </div>
                <div className="col-lg-9 col-sm-12 text-silver p-1">
                  <p className="fs-lg-3 fs-sm-4 my-3">
                    RecruitAI — AI Recruitment Automation Platform
                  </p>
                  <span className="fs-5">
                    Built an AI-powered recruitment workflow system that
                    automates resume parsing, candidate scoring, ranking, and
                    interview scheduling using automation agents. Integrated
                    AI-driven decision logic and workflow orchestration to
                    streamline hiring processes and reduce manual screening
                    time.
                  </span>
                </div>
              </div>
            </a>
          </div>
          <div
            className="project-cards p-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <a
              href="https://houseoftarasya.in"
              className="project-card-link"
              title="Click to see the live project"
            >
              <div className="card row border rounded p-0 my-">
                <div className="col-lg-3 col-sm-12">
                  <img className="rounded" src={project3} alt="" />
                </div>
                <div className="col-lg-9 col-sm-12 text-silver p-1">
                  <p className="fs-lg-3 fs-sm-4 my-3">
                    House of Tarasya — E-commerce Jewelry Website
                  </p>
                  <span className="fs-5">
                    Developed a fully functional e-commerce platform for a
                    handcrafted gemstone jewelry brand, enabling product
                    browsing, catalog management, and online purchasing.
                    Implemented responsive UI, optimized product pages for
                    performance, and deployed the application on a production
                    server with secure payment and hosting configuration.
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div id="experience" className="expreience text-silver">
          <p className="fs-1 mb-0 text-center">Experience</p>
          <div className="row p-4">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2 pb-4">
              <div className="border p-2 rounded">
                <div className="fs-lg-3 fs-sm-4">
                  Freelance Full Stack Developer{" "}
                  <button className="btn ">Self-Employed | Remote</button>
                </div>
                <div
                  className="my-5 fs-5"
                  style={{ textAlign: "justify", lineHeight: "1.5rem" }}
                >
                  Delivered multiple client projects across e-commerce, fashion
                  retail, and AI recruitment domains, handling end-to-end
                  development from requirement gathering to deployment. Built
                  scalable web applications with modern UI/UX, secure
                  authentication, and third-party integrations. Optimized
                  performance, ensured responsive design, and deployed
                  production-ready solutions on cloud/Linux servers.
                  Collaborated directly with clients to translate business needs
                  into functional digital products and automated workflows.
                </div>
                <div className="my-3">
                  <button className="btn mx-1">n8n</button>
                  <button className="btn mx-1">AI Agents</button>
                  <button className="btn mx-1">Prompt Engineering</button>
                  <button className="btn mx-1">Shopify</button>
                  <button className="btn mx-1">React.js</button>
                  <button className="btn mx-1">Node.js</button>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2 pb-4">
              <div className="border rounded p-2">
                <div className="fs-lg-3 fs-sm-4">
                  Full Stack Developer <button className="btn ">JDTS</button>
                </div>
                <div
                  className="my-5 fs-5"
                  style={{ textAlign: "justify", lineHeight: "1.5rem" }}
                >
                  Developed a restaurant order and management system app that
                  streamlines operations and enhances customer experi ence, a
                  hotel management system integrated with WATI for optimized
                  communication and efficiency, an e-commerce platform featuring
                  a robust administration panel for seam less product and order
                  management, and dynamic, inter active websites with engaging
                  frontends tailored to meet diverse business needs.
                </div>
                <div className="my-3">
                  <button className="btn mx-1">ReactJS</button>
                  <button className="btn mx-1">NodeJS</button>
                  <button className="btn mx-1">MongoDB</button>
                  <button className="btn mx-1">ExpressJS</button>
                  <button className="btn mx-1">Nginx</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="getintouch" className="getintouch">
          <p className="fs-1 text-center text-silver">Get In Touch</p>
          <div
            className="form"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <div
              className="form-container border rounded p-2 fs-5"
              style={{ width: "400px" }}
            >
              <input
                className="p-2 rounded border w-100 fs-5"
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <br />
              <input
                className="p-2 rounded border my-3 w-100 fs-5"
                type="text"
                placeholder="Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <br />
              <input
                className="p-2 rounded border my-3 w-100 fs-5"
                type="text"
                placeholder="Type Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <br />
              <button className="btn p-2 w-100" onClick={onSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
        <div className="footer-socials">
          <div className="text-center text-silver" style={{ fontSize: "16px" }}>
            <a
              href="mailto:bittusharma1777@gmail.com"
              className="mx-2 text-decoration-none text-silver"
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </a>

            <a
              href="https://www.linkedin.com/in/aryan-sharma-42469924b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 text-decoration-none text-silver"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>

            <a
              href="https://www.instagram.com/aka_aryan__"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 text-decoration-none text-silver"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://www.facebook.com/share/16DUQZyeKr/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 text-decoration-none text-silver"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>

            <a
              href="https://github.com/mac0aryan"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 text-decoration-none text-silver"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
